import RpcService              from '@/core/services/Rpc/RpcService';
import RpcResponse             from '@/core/services/Rpc/RpcResponse';

class TenderParticipationDAO {

	static async  updateParticipation(participation: any): Promise<RpcResponse> {
		return await RpcService.makeRequest('tenders.updateParticipation', { participation });
	}
}
export default TenderParticipationDAO;
